export const REACT_APP_API_URL="https://coursescheduler-api-eight.vercel.app/"
// export const REACT_APP_API_URL="http://localhost:8000/"
export const REACT_APP_ACADEMIC_YEAR_FOR_WINTER="2026"
export const REACT_APP_ACADEMIC_YEAR_FOR_SUMMER="2024"